<template>
  <div>
        <!-- controls -->
        <div class="field is-horizontal">
            <div class="field-body">
                <div class="field">
                    <label class="label">Date Range</label>
                    <div class="control has-icons-left">
                        <input class="input" type="text" placeholder="Date From - To" readonly ref="date" :disabled="loading">
                        <span class="icon is-small is-left">
                        <i class="fas fa-calendar-alt"></i>
                        </span>
                    </div>
                </div>
                <div class="field">
                    <label class="label">Client</label>
                    <p class="control is-expanded">
                        <div class="select is-fullwidth">
                            <select v-model="client" :disabled="loading">
                                <option v-for="(c,i) in clients" :value="c" :key="i">{{c.name}}</option>
                            </select>
                        </div>
                    </p>
                </div>
                <div class="field">
                    <label class="label">Game categories</label>
                    <p class="control is-expanded">
                        <div class="select is-multiple is-fullwidth">
                        <select v-model="selectedGameCategories"
                                :disabled="loading"
                                multiple
                                size="10">
                                <option v-for="(c,i) in gameCategories" :value="c" :key="i">{{c}}</option>
                            </select>
                        </div>
                    </p>
                </div>
                <div class="field">
                    <label class="label">Game providers</label>
                    <p class="control is-expanded">
                        <div class="select is-multiple is-fullwidth">
                        <select v-model="selectedGameProviders"
                                :disabled="loading"
                                multiple
                                size="10">
                                <option v-for="(p,i) in gameProviders" :value="p" :key="i">{{p}}</option>
                            </select>
                        </div>
                    </p>
                </div>
                <div class="field">
                    <label class="label">Currency</label>
                    <p class="control is-expanded">
                        <div class="select is-fullwidth">
                            <select v-model="currency" :disabled="loading">
                                <option :value="null">All</option>
                                <option v-for="(c,i) in currencies" :value="c" :key="i">{{c.id}}</option>
                            </select>
                        </div>
                    </p>
                </div>
            </div>
        </div>

        <div class="field">
            <button class="button is-primary" @click="load">Filter</button>
        </div>

        <table class="table is-fullwidth">
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Currency</th>
                    
                    <th>Stake count</th>
                    <th>Stake</th>
                    <th>Stake tax</th>
                    <th>Bet</th>
                    
                    <th>Win count</th>
                    <th>Win</th>
                    <th>Win tax</th>
                    <th>Payout</th>
                </tr>
            </thead>
            <tbody v-for="(dateItem, dateIndex) in statsItems" :key="`date-${dateIndex}`">
                <tr v-for="(item, index) in dateItem.currencies" :key="`currency-${dateIndex}-${index}`">
                    <td
                        v-if="index == 0"
                        :rowspan="dateItem.currencies.length">{{dateItem.date | date}}</td>
                    <td>{{ item.currency }}</td>
                    
                    <td>{{ item.stakeCount }}</td>
                    <td>{{ item.stake | currency(item.currency) }}</td>
                    <td class="has-text-weight-bold">{{ item.stakeTax | currency(item.currency) }}</td>
                    <td>{{ item.stake - item.stakeTax | currency(item.currency) }}</td>

                    <td>{{ item.winCount }}</td>
                    <td>{{ item.payout + item.winTax | currency(item.currency) }}</td>
                    <td class="has-text-weight-bold">{{ item.winTax | currency(item.currency) }}</td>
                    <td>{{ item.payout | currency(item.currency) }}</td>
                </tr>
            </tbody>
            <tfoot class="has-text-weight-bold">
                <tr v-for="(currencyItem, currencyIndex) in totalItems" :key="`total-${currencyIndex}`">
                    <td
                        v-if="currencyIndex == 0"
                        :rowspan="Object.keys(totalItems).length">Total</td>
                    <td>{{ currencyItem.currency }}</td>

                    <td>{{ currencyItem.stakeCount }}</td>
                    <td>{{ currencyItem.stake | currency(currencyItem.currency) }}</td>
                    <td class="has-text-weight-bold">{{ currencyItem.stakeTax | currency(currencyItem.currency) }}</td>
                    <td>{{ currencyItem.stake - currencyItem.stakeTax | currency(currencyItem.currency) }}</td>
                    
                    <td>{{ currencyItem.winCount }}</td>
                    <td>{{ currencyItem.payout + currencyItem.winTax | currency(currencyItem.currency) }}</td>
                    <td class="has-text-weight-bold">{{ currencyItem.winTax | currency(currencyItem.currency) }}</td>
                    <td>{{ currencyItem.payout | currency(currencyItem.currency) }}</td>
                </tr>
            </tfoot>
        </table>

    </div>
</template>

<script>
import flatpickr from "flatpickr";
import state from '../../state';
import dt from '../../services/datetime.service';
import statsService from '../../services/stats.service';
import clientService from '../../services/client.service';
import gameService from '../../services/game.service';

export default {
    name: 'stats-taxes',
    data() {
        return {
            loading: false,
            calendar: null,
            client: null,
            currency: null,
            gameCategories: [],
            selectedGameCategories: [],
            gameProviders: [],
            selectedGameProviders: [],
            stats: {
                items: []
            },
        }
    },
    computed: {
        clients() {
            return state.clients.get();
        },
        currencies() {
            return state.currencies.get();
        },
        statsItems () {
            const result = []
            for (let di = 0; di < this.stats.items.length; di++) {
                const dateItem = this.stats.items[di];
                result.push({
                    date: dateItem.date,
                    currencies: dateItem.currencies,
                })
            }
            return result;
        },
        totalItems () {
            const dict = {};
            for (let di = 0; di < this.stats.items.length; di++) {
                const dateItem = this.stats.items[di];

                for (let ci = 0; ci < dateItem.currencies.length; ci++) {
                    const currencyItem = dateItem.currencies[ci];
                
                    // if (this.currency
                    //     && this.currency.id !== currencyItem.currency) continue;

                    if (!dict[currencyItem.currency]) {
                        dict[currencyItem.currency] = {
                            currency: currencyItem.currency,
                            stakeCount: 0,
                            stake: 0,
                            stakeTax: 0,
                            winCount: 0,
                            winTax: 0,
                            payout: 0,
                        }
                    }

                    dict[currencyItem.currency].stakeCount += currencyItem.stakeCount;
                    dict[currencyItem.currency].stake += currencyItem.stake;
                    dict[currencyItem.currency].stakeTax += currencyItem.stakeTax;
                    dict[currencyItem.currency].winCount += currencyItem.winCount;
                    dict[currencyItem.currency].winTax += currencyItem.winTax;
                    dict[currencyItem.currency].payout += currencyItem.payout;
                }
            }

            const result = [];
            for (const key in dict) {
                result.push(dict[key])
            }
            return result;
        }
    },
    methods: {
        async load() {
            const start = dt.fixDate(this.$data.calendar.selectedDates[0]);
            const end = dt.fixDate(this.$data.calendar.selectedDates[1]);
            const from = dt.local(start).utc().toISOString();
            const to = dt.local(end).endOf("day").utc().toISOString();

            this.loading = true;
            this.stats = await statsService.getTaxesStats(
                this.client.id,
                from,
                to,
                this.selectedGameCategories,
                this.selectedGameProviders,
                this.currency ? this.currency.id : undefined);
            this.loading = false;
        },
        getSumTaxes (item) {
            return item.stakeTax
                + item.winTax
        },
        async loadGameCategories () {
            this.gameCategories = await gameService.getGameCategories(this.client);
            this.gameCategories.sort((a, b) => a.localeCompare(b));
        },
        async loadGameProviders () {
            this.gameProviders = await gameService.getGameProviders();
            this.gameProviders.sort((a, b) => a.localeCompare(b));
        }
    },
    watch: {
        async client () {
            await this.loadGameCategories();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.client = this.clients.filter(c => c.name == 'MBK777')[0];

        await this.loadGameProviders();
        await this.loadGameCategories();

        let start = dt.local(new Date()).add(-6, 'days').format("YYYY-MM-DD");
        let end = dt.local(new Date()).format("YYYY-MM-DD");
        this.$data.calendar = flatpickr(this.$refs.date, {
        mode: "range",
        maxDate: "today",
        defaultDate: [
            start,
            end
        ]
        });

    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// front/src/components/stats/taxes.vue